export function waitImagesLoaded(root: HTMLElement): Promise<void[]> {
  return Promise.all(
    Array.from(root.querySelectorAll("img")).map((img) =>
      img.complete
        ? Promise.resolve()
        : new Promise<void>((res) =>
            img.addEventListener("load", () => res(), { once: true }),
          ),
    ),
  );
}

export function buildComprovanteEnvioV2PdfOptions(solicitacaoId: number) {
  const stamp = new Date().toISOString().slice(0, 10);
  return {
    margin: [8, 8, 8, 8] as [number, number, number, number],
    filename: `documentacao_enviada_${solicitacaoId}_${stamp}.pdf`,
    image: { type: "jpeg" as const, quality: 1 },
    html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
    jsPDF: { unit: "mm" as const, format: "a4" as const, orientation: "portrait" as const },
    pagebreak: {
      mode: ["css", "legacy"] as const,
      avoid: [".visao-geral-associado-bloco", ".visao-geral-document-group"],
    },
  };
}

async function loadHtml2Pdf() {
  const html2pdfLib = await import("html2pdf.js");
  return html2pdfLib?.default ?? html2pdfLib;
}

export async function gerarPdfBlobComprovanteEnvioV2(
  element: HTMLElement,
  solicitacaoId: number,
): Promise<Blob> {
  const html2pdf = await loadHtml2Pdf();
  await waitImagesLoaded(element);
  const opt = buildComprovanteEnvioV2PdfOptions(solicitacaoId);

  try {
    return await html2pdf().set(opt).from(element).outputPdf("blob");
  } catch {
    return await html2pdf().set(opt).from(element).output("blob");
  }
}

export async function salvarPdfComprovanteEnvioV2(
  element: HTMLElement,
  solicitacaoId: number,
): Promise<void> {
  const html2pdf = await loadHtml2Pdf();
  await waitImagesLoaded(element);
  const opt = buildComprovanteEnvioV2PdfOptions(solicitacaoId);
  await html2pdf().set(opt).from(element).save();
}
